import React from 'react';

const Header: React.FC = () => {
  return (
    <header id="main-header" className="main-header">
      <div className="main-header__inner inner">
        <a href='/facility/top' className="main-header__logo">
          <picture>
            <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-sp.webp`} media="(max-width:834px)" type="image/webp" />
            <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo-sp.png`} media="(max-width:834px)" />
            <source srcSet={`${process.env.PUBLIC_URL}/img/webp/common/logo.webp`} type="image/webp" />
            <img src={`${process.env.PUBLIC_URL}/img/common/logo.png`} alt="SEED" />
          </picture>
        </a>
      </div>
    </header>
  )
}

export default Header;